<template>
	<div class="Aboutus">
		<navbarv2 />
		<header class="header">
			<img src="../../assets/images/aboutus/about-us-banner.png" class="desktop-img">

			<div class="mobile-banner-section">
				<div class="title"> NymbleUp is an AI powered suite of tools that help retailer drive profitability by generating demand, optimizing workforce and inventory</div>
			</div>
		</header>

		<div class="about-us-container mb-8">
			<div class="descp-col mt-10">
				<div>
					<h2 class="title">
						Who We Are
					</h2>
					<div class="descp">
						<p>
							NymbleUp was started with a vision to change retail industry by automating decision making in key aspects of retail operations using Artificial Intelligence
						</p>
					</div>
				</div>
				<div>
					<img src="../../assets/images/aboutus/who-we-are.svg">
				</div>
			</div>

			<div class="descp-col mt-10">
				<div>
					<img src="../../assets/images/aboutus/our-vision.svg">
				</div>
				<div>
					<h2 class="title">
						Our Vision
					</h2>
					<div class="descp">
						<p>
							Our vision is to make adoption of cutting edge technologies easy, cost effective and non disruptive for any retailer regardless of their size and scale.
						</p>
					</div>
				</div>
			</div>

			<div class="descp-col mt-10">
				<div>
					<h2 class="title">
						Team
					</h2>
					<div class="descp">
						<p>
							We are a team of engineers with hands-on experience in retail and technology. Since starting our operations in 2019, we are working with some of the most recognised Food Services Brand globally
						</p>
					</div>
				</div>
				<div>
					<img src="../../assets/images/aboutus/team.svg">
				</div>
			</div>

			<div class="descp-col mt-10">
				<div>
					<img src="../../assets/images/aboutus/where-are-we.svg">
				</div>
				<div>
					<h2 class="title">
						Where Are We Headed
					</h2>
					<div class="descp">
						<p>
							We are working towards creating a truly intelligent automation platform that helps retailers manage complex tasks such as promotion planning, demand forecasting, workforce scheduling and planning
						</p>
						<p class="mt-4">
							We are constantly studying and researching emerging technologies in IOT, ML with a view to address complex challenges in the retail industry.
						</p>
					</div>
				</div>
			</div>
		</div>

		<requestDemo />

		<footerbar />
	</div>
</template>
<script>
import RequestDemoBar from '../../components/requestDemoBar/RequestDemoBar.vue';
export default {
	name: "Aboutus",
	components: {
		'requestDemo': RequestDemoBar
	},
    metaInfo() {
        return {
            title: 'Advanced Retail Planning Platform',
            titleTemplate: '%s - NymbleUp',
            htmlAttrs: {
              lang: 'en',
              amp: true
            },
            meta: [
              {
                vmid: 'title',
                name: 'title',
                content: 'Advanced Retail Planning Platform - NymbleUp'
              },
              {
                vmid: 'description',
                name: 'description',
                content: 'Our automation platform helps retailers manage tasks like promotion planning, demand forecasting, workforce scheduling & planning. To know more visit NymbleUp.'
              }
            ]
        }
    },
};
</script>
<style lang="scss" scoped>
.Aboutus .header {
	width: 100%;
	// background-image: url('../../assets/images/homepage/banner.jpg');
	// background-repeat: no-repeat;
	// background-size: cover;
    // background: black;
	height: 80vh!important;
    overflow: hidden;
	.desktop-img {
		margin-top: 60px;
		object-fit: cover;
		// opacity: 0.4;
		height: 100%;
		width: 100%;
	}

	.mobile-banner-section{
		position: relative;
		display: none;
		background-color: #000;
		height: 100%;
		.title{
			position: absolute;
			top: 40%;
			left: 0;
			right: 0;
			width: 85%;
			margin: 0 auto;
			color: #fff;
			font-size: 1.9rem;
			line-height: 1.5;
			text-align: center;
		}
	}
}
.Aboutus .about-us-container{
	// padding: 0 20px;

	.title{
		font-size: 1.4rem;
		font-weight: 700;
		margin: 40px 0 40px 0;
		position: relative;
	}

	.title::after{
		position: absolute;
		bottom: -35px;
		left: 22px;
		width: 40px;
		height: 1px;
		margin-bottom: 15px;
		content: "";
		transform: translateX(-50%);
		background-color: #E29D5A;
	}
	.descp{
		width: 400px;
		p{
			font-size: 1rem;
			color: #000;
			line-height: 1.5;
		}
	}
	.descp-col{
		display: flex;
		justify-content: space-around;
		// align-items: center;
		img{
			width: 400px;
			margin-top: 30px;
		}
	}
	.request-demo-section{
		// background: linear-gradient(#5a66fa 0%, #212975 95.02%, #1e266e 100%, #1d266c 100%, #1e266e 100%)!important;
		background-color: #707070;
		// background-color: #232937;
		// border-bottom: 1px solid #b9bdbe;
		padding: 50px 20px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-around;

		.head-title{
			font-size: 25px;
			font-weight: 600;
			color: #fff;
			line-height: 1.8;
		}
		small{
			color: #fff;
			display: block;
		}

		.request-btn{
			border: 1px solid #e29d5a;
			background-color: #e29d5a;
			color: #fff;
			font-size: 16px;
			font-weight: 500;
			padding: 5px;
			height: 50px;
			width: 150px;
			-webkit-transition: .3s;
			transition: .3s;
			margin: 35px;
		}
		.request-btn:hover{
			border: 1px solid #e29d5a;
			background-color: #e29d5a;
			color: #fff;
		}
	}
}
@media screen and (max-width: 575px) {
	.Aboutus .header .mobile-banner-section{
		.title{
			top: 35%;
			font-size: 1.6rem;
		}
	}
}
@media screen and (max-width: 992px) {
	.Aboutus .header img{
		display: none;
	}
	.Aboutus .header .mobile-banner-section{
		display: block;
		.title{
			width: 90%;
		}
	}
	.Aboutus .about-us-container{
		.descp-col{
			display: block!important;
			text-align: center;
		}

		.title{
			text-align: center;
		}

		.title::after{
			left: 50%;
		}
		.descp{
			width: 80%;
			margin: 0 auto;
		}
	}
}
</style>
